module.exports = __webpack_public_path__ + "static/img/72db83bd-854c-4077-89e6-900798d2ea65.1c8c3439.png";